import { useState } from 'react';
import { sessionStore } from '../../api/session';
import { useActiveLibraryId } from '../../data/activeLibrary';
import { userScopeKey } from '../../data/scope';
import { useStore } from '../../lib/store';

interface ShellKeyState {
  scope: string;
  /** Last resolved library. */
  library: string | null;
  /** The library part of the key. */
  keyLibrary: string;
}

/**
 * The signed-in shell's React key: Flutter's user-scoped fingerprint
 * (`type|url|userId|libraryId`, SHELL-004). The library part changes only when
 * one resolved library is replaced by another, so the first resolution after
 * sign-in (null → id) does not remount the shell.
 */
export function useShellKey(): string {
  const scope = useStore(sessionStore, (s) => userScopeKey(s) ?? '');
  const library = useActiveLibraryId();
  const [state, setState] = useState<ShellKeyState>({ scope, library, keyLibrary: library ?? '' });

  let next = state;
  if (state.scope !== scope) next = { scope, library, keyLibrary: library ?? '' };
  else if (library && library !== state.library) next = { scope, library, keyLibrary: state.library ? library : state.keyLibrary };
  if (next !== state) setState(next);

  return `${next.scope}|${next.keyLibrary}`;
}
